import React from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import { mainTable } from "../css/Common";

const PaymentInfoPopup = ({ data,data1 }) => {
  return (
    <div class="w-full">
      {/* <Loader
    isVisible={isLoading}
    size="h-20 w-20"
    color="border-t-black"
    blur={true}
  /> */}
      <div class={mainTable.mainContentScreen}>
        <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
          <div class={mainTable.grid2}>
            <InputText
              inputType="date"
              title="Payment Date"
              classStar="text-red-500"
              name="date"
              content={data?.UnformattedDate?.split("T")[0]}
              disabled={true}
            />
            <div></div>
            <div>
              <DropDown
                name="paymentMethod"
                title="Payment Method"
                classStar="text-red-500"
                selectedOption={data?.PaymentMethodId}
                options={data1}
                placeholder="Select Payment Method"
                tabIndex="1"
                disabled={true}
              />
            </div>
            <InputText
              inputType="text"
              title="Remarks"
              name="remarks"
              content={data?.Remarks}
              maxLength={500}
              classStar="text-red-500"
              disabled={true}
            />

            <InputText
              inputType="text"
              title="Bank"
              name="bank"
              content={data?.Bank}
              maxLength={100}
              classStar="text-red-500"
              disabled={true}
            />

            <InputText
              inputType="text"
              title="Bank Branch"
              name="bankBranch"
              content={data?.BankBranch}
              maxLength={100}
              classStar="text-red-500"
              disabled={true}
            />

            <InputText
              inputType="text"
              title="Amount"
              name="amount"
              content={data?.Amount}
              maxLength={13}
              classStar="text-red-500"
              disabled={true}
            />
            <InputText
              inputType="text"
              title="Reference Number"
              name="referenceNumber"
              content={data?.ReferenceNumber}
              maxLength={50}
              classStar="text-red-500"
              disabled={true}
            />
            <img src={data?.AttachmentFile} alt="Payment"  />
          </div>

        </form>
      </div>
    </div>
  );
};

export default PaymentInfoPopup;
